"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var ra_fetch_1 = require("ra-fetch");
var Profile = function (_a) {
    var _b = _a.user, user = _b === void 0 ? {} : _b;
    var _c = react_1.useState(false), open = _c[0], setOpen = _c[1];
    var _d = ra_fetch_1.useApi('auth').logout(), logout = _d[0], setLogout = _d[1], submitLogout = _d[2];
    return react_1.default.createElement("div", { className: 'storybook-menus-dashboard-nav-profile' },
        user.id && react_1.default.createElement(storybook_1.Icons.Icon, { name: 'check', className: 'storybook-menus-dashboard-nav-profile-logged' }),
        react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () {
                if (user.id) {
                    return setOpen(!open);
                }
                window.location.href = process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/login";
            } },
            react_1.default.createElement(storybook_1.Menus.Dashboard.Avatar, null)),
        user.id && react_1.default.createElement(storybook_1.Dropdowns.Container, { open: open, align: 'right', onClose: function () { return setOpen(!open); } },
            react_1.default.createElement(storybook_1.Dropdowns.Link, { to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/profile" }, "Mijn profiel"),
            react_1.default.createElement(storybook_1.Dropdowns.Link, { to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/profile/payments" }, "Aankopen"),
            react_1.default.createElement(storybook_1.Dropdowns.Link, { to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/profile/subscriptions" }, "Abonnementen"),
            user.permissions.includes('api.videos.index') &&
                react_1.default.createElement(storybook_1.Dropdowns.Link, { to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/videos" }, "Video's"),
            react_1.default.createElement(storybook_1.Dropdowns.LinkButton, { onClick: function () {
                    submitLogout().then(function () {
                        window.location.href = process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/login";
                    });
                } }, "Uitloggen")));
};
exports.Profile = Profile;
exports.Profile.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number,
        permissions: prop_types_1.default.array,
    }),
};
exports.Profile.defaultProps = {};
